import React, { createContext, useState, useEffect, useContext } from 'react';
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import { Button, Card } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import _ from 'lodash';
import CustomerUserService from '../../services/CustomerUserService';
import { CustomerContext } from '../../contexts/CustomerContext';
import { AuthContext } from '../../contexts/AuthContext';
import CustomerUsers from '../user/CustomerUsers';
import { userTypes } from '../../utilities/appConstants';

const CustomerUserList = (props) => {
    const [users, setUsers] = useImmer([]);
    const [accountId, setAccountId] = useImmer(0);
    const [accounts, setAccounts] = useImmer([]);
    const [includeDeleted, setIncludeDeleted] = useImmer(false);

    const customerContext = useContext(CustomerContext);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        getUsers();
        const accountId = parseInt(authContext.getClaim(authContext.claims.accountId));
        setAccountId(accountId);
    }, []);

    const getUsers = async () => {
        var userService = new CustomerUserService();
        var callResult = await userService.getUsers({ "includeDeleted": includeDeleted });
        if (callResult.result) {
            setUsers(callResult.model.users);
            setAccounts(callResult.model.accounts);
        }
    }

    const notifyUserChange = (user) => {
        const newUser = {
            id: user.id,
            accountId: user.accountId,
            accountName: user.accountName,
            firstName: user.firstName,
            lastName: user.lastName,
            fullName: user.fullName,
            userType: user.userType,
            roleName: user.roleName,
            userTypeFriendly: user.userTypeFriendly,
            emailAddress: user.emailAddress,
            phoneNumber: user.phoneNumber?.number,
            state: user.state
        };

        setUsers(draft => {
            if (draft === undefined) {
                draft = [];
            }
            _.remove(draft, item => item.id === newUser.id);
            if (newUser.state !== -100) {
                draft.push(newUser);
            }
            draft = draft.sort((a, b) => (a.lastName.toLowerCase() > b.lastName.toLowerCase()) ? 1 : -1);
        });
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Customer User List</div>
            </Card.Header>
            <Card.Body className="card-body-table">
                <CustomerUsers users={users}
                    userType={userTypes.customerUser}
                    accounts={accounts}
                    accountId={accountId}
                    showModal={customerContext.showModal}
                    closeModal={customerContext.hideModal}
                    notifyUserChange={notifyUserChange} />
                {/*<pre>{JSON.stringify(users, null, 2)}</pre>*/}
            </Card.Body>
        </Card>
    )
}

export default CustomerUserList;